import { render } from "./MyBooking.vue?vue&type=template&id=58193ebc"
import script from "./MyBooking.vue?vue&type=script&lang=js"
export * from "./MyBooking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/web_servio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__